import React from 'react';
import { Icon } from '@udemy/icons';
export const BarChartIcon = ({
  className,
  label = false
}) => /*#__PURE__*/React.createElement(Icon, {
  glyph: "bar-chart",
  label: label,
  className: className
});
export const ChatIcon = ({
  className,
  label = false
}) => /*#__PURE__*/React.createElement(Icon, {
  glyph: "chat",
  label: label,
  className: className
});
export const CloudIcon = ({
  className,
  label = false
}) => /*#__PURE__*/React.createElement(Icon, {
  glyph: "cloud",
  label: label,
  className: className
});
export const CodeIcon = ({
  className,
  label = false
}) => /*#__PURE__*/React.createElement(Icon, {
  glyph: "code",
  label: label,
  className: className
});
export const ConsoleIcon = ({
  className,
  label = false
}) => /*#__PURE__*/React.createElement(Icon, {
  glyph: "console",
  label: label,
  className: className
});
export const SecurityIcon = ({
  className,
  label = false
}) => /*#__PURE__*/React.createElement(Icon, {
  glyph: "security",
  label: label,
  className: className
});
export const ServerIcon = ({
  className,
  label = false
}) => /*#__PURE__*/React.createElement(Icon, {
  glyph: "server",
  label: label,
  className: className
});
//# sourceMappingURL=labs-icons.react-component.js.map